// Modules
import React from 'react';
import i18n from 'i18n-react';
import Spinner from '../spinner/SpinnerView';
import SearchResultItems from './SearchResultItems';

const SearchResults = (props) => {
    let content = null;

    if (props.isLoading) {
        content = (
            <ul className="dropdown-menu searchResults">
                <Spinner />
            </ul>
        );
    }

    if (props.searchResults && props.showSearchResults && !props.isLoading) {
        if (props.searchResults.companies.items.length > 0 || props.searchResults.administrations.items.length > 0) {
            content = (
                <ul className="dropdown-menu searchResults">
                    <SearchResultItems
                        header={i18n.translate('company.plural')}
                        items={props.searchResults.companies.items}
                        amountOfMoreResults={props.searchResults.companies.amountOfMoreResults}
                        onSelect={props.onSelectCompany}
                        onClickMoreResults={props.onClickAmountOfResults}
                    />
                    <SearchResultItems
                        header={i18n.translate('administration.plural')}
                        items={props.searchResults.administrations.items}
                        amountOfMoreResults={props.searchResults.administrations.amountOfMoreResults}
                        onSelect={props.onSelectAdministration}
                        onClickMoreResults={props.onClickAmountOfResults}
                    />
                </ul>
            );
        } else if (
            props.searchResults.companies.items.length === 0 &&
            props.searchResults.administrations.items.length === 0
        ) {
            content = (
                <ul className="dropdown-menu searchResults">
                    <li className="dropdown-item no-hover">{i18n.translate('general.overview.noResults')}</li>
                </ul>
            );
        }
    }

    return content;
};

export default SearchResults;
